import React from 'react';
import { Card } from './ui/card';
import { Globe, TrendingUp, Users, Zap } from 'lucide-react';

const GlobalMarkets = () => {
  const markets = [
    {
      region: 'India',
      icon: TrendingUp,
      description: 'Primary market with 12+ years of experience across fintech, education, B2B, media, and consumer brands',
      highlights: ['Managed ₹1000Cr+ in budgets', 'Built teams across Delhi, Mumbai, Bangalore', 'Deep understanding of tier 1/2/3 city dynamics'],
    },
    {
      region: 'United States',
      icon: Globe,
      description: 'Marketing strategies and campaigns for US market entry and customer acquisition',
      highlights: ['B2B SaaS marketing', 'Digital-first acquisition', 'Enterprise sales enablement'],
    },
    {
      region: 'Southeast Asia',
      icon: Users,
      description: 'Regional expansion and localization strategies for SEA markets',
      highlights: ['Market entry planning', 'Localized content strategies', 'Regional partnership marketing'],
    },
    {
      region: 'Middle East',
      icon: Zap,
      description: 'Growth marketing and brand building in GCC countries',
      highlights: ['Dubai & UAE markets', 'B2B & B2C strategies', 'Cultural adaptation of campaigns'],
    },
  ];

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-slate-900 text-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">Global Experience</h2>
          <p className="text-slate-400 text-lg max-w-3xl mx-auto">
            Marketing is never one-size-fits-all. What works in India will not work in the US. 
            What works in Dubai needs adaptation for Singapore. I have learned this by doing it.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {markets.map((market, index) => {
            const Icon = market.icon;
            return (
              <Card key={index} className="p-6 bg-slate-800 border-slate-700 hover:border-slate-600 transition-colors">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon className="text-teal-400" size={24} />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">{market.region}</h3>
                    <p className="text-slate-400 text-sm leading-relaxed">{market.description}</p>
                  </div>
                </div>
                <ul className="space-y-2 mt-4">
                  {market.highlights.map((highlight, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-slate-300 text-sm">
                      <span className="text-teal-400 mt-1">•</span>
                      <span>{highlight}</span>
                    </li>
                  ))}
                </ul>
              </Card>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <p className="text-slate-400">
            Whether it is navigating regulatory frameworks in fintech, understanding education buyer behavior 
            across markets, or adapting brand messaging for cultural nuance—I bring both strategic clarity and 
            on-the-ground execution experience.
          </p>
        </div>
      </div>
    </section>
  );
};

export default GlobalMarkets;
